'use strict'
import React from 'react'
import Slider from 'react-slick'
import { withTranslation as translate } from 'react-i18next'
import FullSearchBar from './search-bars/full-search-bar.jsx'
import StoriesSlider from './home-page/stories-slider.jsx'
import StoriesGrid from './home-page/stories-grid.jsx'
import SubFooter from './home-page/sub-footer.jsx'
import ComponentWithLogin from './component-with-login.jsx'
import { Trans } from 'react-i18next'
import MetaTags from 'react-meta-tags'
import Zendesk from './zendesk.jsx'
import moment from 'moment'
import utils from '../lib/utils'
import { Carousel } from 'react-responsive-carousel'

import HomePageWidgetGroup from './blog-post-widgets/home-page-widget/home-page-widget-group'

const NUM_CHARACTERS_FOR_BLOG_POST_WIDGET = 200

class HomePage extends ComponentWithLogin {
  constructor(props) {
    super(props)
    this.state = {
      nrGuests: 2,
      // roomsData: [],
      showLogin: false,
      img: 1,
      user: this.props.state.userId ? this.props.state.userId : undefined,
      location: undefined,
      mobilityClass: undefined,
      startDate: undefined,
      endDate: undefined,
    }
    this.genereteTopSectionImage = this.genereteTopSectionImage.bind(this)
  }

  componentDidMount() {
    this.props.onSetLocale(this.props.state.locale)
    if (this.props.state.noStore.deviceSize == 'lg') {
      this.interval = setInterval(() => this.setState({ img: Math.floor(Math.random() * 7) + 1 }), 5000)
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate })
  }

  onSearchClick() {
    window.coordsFixed = false
    if (this.state.location) {
      let zoomLevel = '&z=14'
      let path = `/${this.props.state.locale}/search/?q=${encodeURIComponent(this.state.location)}&mobility_class_old=${this.state.mobilityClass}`
      // if (this.state.nrGuests !== 1) {
      //   path += `&nr_guests=${this.state.nrGuests}`
      // }
      if (this.state.startDate && this.state.endDate) {
        path += `&start_date=${utils.getDateString(this.state.startDate)}&end_date=${utils.getDateString(this.state.endDate)}`
      }
      switch (this.state.type) {
        case 'political':
          zoomLevel = '&z=14'
          break
        case 'route':
          zoomLevel = '&z=15'
          break
        case 'locality':
          zoomLevel = '&z=13'
          break
        case 'country':
          zoomLevel = '&z=8'
          break
        case 'administrative_area_level_2':
          zoomLevel = '&z=8'
          break
        case 'administrative_area_level_1':
          zoomLevel = '&z=8'
          break
        case 'neighborhood':
          zoomLevel = '&z=13'
          break
        case 'establishment':
          zoomLevel = '&z=10'
          break
      }
      switch (this.state.location) {
        case 'Malta':
        case 'Isle of Wight':
        case 'Isle of Sheppey':
        case 'Hayling Island':
        case 'Foulness Island':
        case 'Portsea Island':
        case 'Canvey Island':
        case 'Mersea Island':
        case 'Walney Island':
        case 'Wallasea Island':
        case 'Lundy':
        case 'Isles of Scilly':
        case 'Shetland':
        case 'Orkney':
        case 'Outer Hebrides':
        case 'Inner Hebrides':
        case 'Islands of the Clyde':
        case 'Islands of the Forth':
        case 'Outlying islands':
        case 'Lewis and Harris':
        case 'Skye':
        case 'Mainland, Shetland':
        case 'Mull':
        case 'Islay':
        case 'Mainland, Orkney':
        case 'Arran':
        case 'Jura':
        case 'South Uist':
        case 'North Uist':
        case 'Anglesey':
        case 'Holy Island':
        case 'Skomer':
        case 'Ramsey Island':
        case 'Caldey Island':
        case 'Achill Island':
        case 'Aran Islands':
        case 'Rathlin Island':
        case 'Jersey':
        case 'Guernsey':
        case 'Alderney':
        case 'Isle of Man':
        case 'Bornholm':
        case 'Falster':
        case 'Funen':
        case 'Lolland':
        case 'Zealand':
        case 'Abruka':
        case 'Hiiumaa':
        case 'Kihnu':
        case 'Muhumaa':
        case 'Naissaar':
        case 'Osmussaar':
        case 'Piirissaar':
        case 'Ruhnu':
        case 'Saaremaa':
        case 'Vilsandi':
        case 'Vormsi':
        case 'Gotland':
        case 'Öland':
        case 'Orust':
        case 'Hisingen':
        case 'Värmdö':
        case 'Tjörn':
        case 'Åland Islands':
        case 'Fehmarn':
        case 'Hailuoto':
        case 'Rügen':
        case 'Usedom/Uznam':
        case 'Wolin':
        case 'Azores':
        case 'Madeira':
        case 'Canary Islands':
        case 'Faroe Islands':
        case 'Frisian Islands':
        case 'Danish Wadden Sea Islands':
        case 'North Jutlandic Island':
        case 'Balearic Islands':
        case 'Comino':
        case 'Cominotto':
        case 'Corsica':
        case 'Elba':
        case 'Fungus Rock':
        case 'Gozo':
        case 'Filfla':
        case 'Ischia':
        case 'Lampedusa':
        case 'Manoel Island':
        case 'Pantelleria':
        case 'Ponza':
        case 'Sardinia':
        case 'Sicily':
        case 'St. Paul\'s Islands':
        case 'Crete':
        case 'Euboea':
        case 'Lesbos Island':
        case 'Rhodes':
        case 'Chios':
        case 'Cyclades':
        case 'Dodecanese':
        case 'Sporades':
        case 'Northeastern Aegean Islands':
        case 'Argo-Saronic Islands':
        case 'Ionian Islands':
        case 'Sveti Nikola Island':
        case 'Krk':
        case 'Rab':
        case 'Cres':
        case 'Pag':
        case 'Hvar':
        case 'Dugi Otok':
        case 'Mljet':
        case 'Brač':
        case 'Korčula':
        case 'Lošinj':
        case 'Šolta':
        case 'Ugljan':
        case 'Lastovo':
        case 'Čiovo':
        case 'Molat':
        case 'Vir':
        case 'Andorra':
          zoomLevel = '&z=11'
          break
        case 'Cyprus':
          zoomLevel = '&z=8'
          break
      }
      path += zoomLevel
      this.props.router.push(path)
    }
  }

  onReceivedSearchResults(searchQuery, features) {
    if (features && features.length > 0) {
      const feature = features[0]
      this.setState({ type: feature.properties.types[0], type2: feature.properties.types[1] })
    }
  }
  // onChangeNrGuests(nrGuests) {
  //   this.setState({ nrGuests })
  // }

  onMobilityClassChange(mobilityClass) {
    this.setState({ mobilityClass })
  }

  onSearchQueryChange(location) {
    this.setState({ location })
  }

  genereteTopSectionImage() {
    return (
      'home-page__top-section ' + 'home-page__top-section-' + this.state.img
    )
  }

  render() {
    const _t = this.props.t
    let haccessURLLang;
    if (this.props.state.locale && this.props.state.locale === "en" || this.props.state.locale === "en-GB") {
      haccessURLLang = "/"
    } else if (this.props.state.locale && this.props.state.locale === "da" || this.props.state.locale === "da-dk") {
      haccessURLLang = "/da/"
    } else if (this.props.state.locale && this.props.state.locale === "fr" || this.props.state.locale === "fr-fr") {
      haccessURLLang = "/fr/"
    } else if (this.props.state.locale && this.props.state.locale === "sv" || this.props.state.locale === "sv-se") {
      haccessURLLang = "/sv/"
    } else {
      haccessURLLang = "/"
    }
    const destinationSliderSettings = {
      dots: true,
      infinite: true,
      autoplay: false,
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      useCss: true,
      className: 'destination-slider',
      dotsClass: 'destination-slider-dots',
      arrows: false,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      }, {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    }

    let searchProps = Object.assign({}, this.props, {
      onReceivedSearchResults: this.onReceivedSearchResults,
      onMobilityClassChange: this.onMobilityClassChange,
      onSearchQueryChange: this.onSearchQueryChange,
      searchQuery: this.state.location,
      mobilityClass: this.state.mobilityClass,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      onDatesChange: this.onDatesChange,
      onSearchClick: this.onSearchClick,
      // onChangeNrGuests: this.onChangeNrGuests,
      // nrGuests: this.state.nrGuests,
      // roomsData: this.state.roomsData,
      state: this.props.state,
      datesPreOpen: true
    })
    let dSize = this.props.state.noStore.deviceSize
    let searchComponent = null
    // searchComponent = <FullSearchBar {...searchProps} />
    let infoSection = (
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <h2 className='info-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_page_why_subheader') }}></h2>
            <p className='info-section-text' dangerouslySetInnerHTML={{ __html: _t('homepage_page_why_body') }}></p>
          </div>
        </div>

        <div className='row info-section-columns'>
          <div className='col-md-3 col-sm-6 col-xs-12 info-section-column info-section-column-1'>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspAccData`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_1_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_1_textx') }}></div>
            </a>
          </div>
          <div className='col-md-3 col-sm-6 col-xs-12 info-section-column info-section-column-2'>
            <a href={`${HOST_URL}/${this.props.state.locale}/howItWorks`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_2_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_2_text') }}></div>
            </a>
          </div>
          <div className='col-md-3 col-sm-6 col-xs-12 info-section-column info-section-column-3'>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspCustomerService`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_3_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_3_text') }}></div>
            </a>
          </div>
          <div className='col-md-3 col-sm-6 col-xs-12 info-section-column info-section-column-4'>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspGreatPrice`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_4_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_4_text') }}></div>
            </a>
          </div>
        </div>
      </div>
    )
    let topSection = (<section className={this.genereteTopSectionImage()}>
      <a className="header-contact" href="tel:+44 1550 400022">
        <strong dangerouslySetInnerHTML={{ __html: _t('landing_page_top_need') }}></strong>
        <strong>{'+44 1550 400022'}</strong>
        {/*<strong><Trans i18nKey="landing_page_contact_phone"><a className="phone" href="tel:00441550400022">+44 1550 400022 (UK)</a></Trans></strong>*/}
      </a>
      <div className='home-page__top-section-content'>
        <div className='home-page__top-title'>
          <div>
            <h2><span dangerouslySetInnerHTML={{ __html: _t('homepage_top_header') }}></span></h2>
            <h4><span dangerouslySetInnerHTML={{ __html: _t('homepage_top_header_sub') }}></span></h4>
          </div>
          <div
            className="feefo-logo-block"
          >

          </div>
        </div>
        {/*{searchComponent}*/}
      </div>
    </section>)
    if (dSize === 'xs' || dSize === 'sm') {
      // topSection = searchComponent
      topSection = null
      infoSection = (
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h2 className='info-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_page_why_subheader') }}></h2>
            </div>
          </div>
          <Carousel showThumbs={false} showStatus={false}>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspAccData`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_1_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_1_textx') }}></div>
            </a>
            <a href={`${HOST_URL}/${this.props.state.locale}/howItWorks`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_2_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_2_text') }}></div>
            </a>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspCustomerService`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_3_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_3_text') }}></div>
            </a>
            <a href={`${HOST_URL}/${this.props.state.locale}/uspGreatPrice`} target="_blank" className='info-section-column-content'>
              <div className='info-section-title m-inner' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_4_header') }}></div>
              <div className='info-section-column-text' dangerouslySetInnerHTML={{ __html: _t('homepage_why_card_4_text') }}></div>
            </a>
          </Carousel>
        </div>
      )
    }


    return (
      <div className='home-page'>
        <MetaTags>
          <title>{_t('seo_title_home')}</title>
          <meta name="description" content={_t('seo_description_home')} />
        </MetaTags>
        <Zendesk delay='20000' {...this.props} />
        <div className='home-page__content'>
          {topSection}
          {/*<section className='info-section'>*/}
          {/*  {infoSection}*/}
          {/*</section>*/}

          <section className='stories-section'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <h2 className='stories-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_community_stories_header') }}></h2>
                  <div className='stories-section-text' dangerouslySetInnerHTML={{ __html: _t('homepage_community_stories_text') }}></div>
                </div>
              </div>
              <HomePageWidgetGroup
                isSignedIn={this.props.isSignedIn}
                fetchPrioritizedPostIds={this.props.fetchPrioritizedPostIds}
                fetchPostsByIds={this.props.fetchPostsByIds}
                shortTextLength={NUM_CHARACTERS_FOR_BLOG_POST_WIDGET}
                currentLang={this.props.i18n.language}
              />
            </div>
          </section>

          {/*<section className='info-section'>*/}
          {/*  <div className='container'>*/}
          {/*    <div className='row'>*/}
          {/*      <div className='col-md-12'>*/}
          {/*        <h2 className='info-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_destinations_header') }}></h2>*/}
          {/*        <div className='info-section-text' dangerouslySetInnerHTML={{ __html: _t('homepage_destinations_header_sub') }}></div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  <div className='destination-slider-wrapper'>*/}
          {/*    <Slider {...destinationSliderSettings}>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item barcelona' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Barcelona,Spain`} title={_t('general_locations_barcelona')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/barcelona.jpg')} alt={`View of ${_t('general_locations_barcelona')}`} title={_t('general_locations_barcelona')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_barcelona') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item london' href={`${HOST_URL}/${this.props.state.locale}/search/?q=London`} title={_t('general_locations_london')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-london.jpg')} alt={`View of ${_t('general_locations_london')}`} title={_t('general_locations_london')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_london') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item paris' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Paris`} title={_t('general_locations_paris')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-paris.jpg')} alt={`View of ${_t('general_locations_paris')}`} title={_t('general_locations_paris')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_paris') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item mallorca' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Mallorca`} title={_t('general_locations_mallorca')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/mallorca.jpg')} alt={`View of ${_t('general_locations_mallorca')}`} title={_t('general_locations_mallorca')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_mallorca') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item croatia' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Croatia`} title={_t('general_countries_croatia')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-croatia.jpg')} alt={`View of ${_t('general_countries_croatia')}`} title={_t('general_countries_croatia')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_countries_croatia') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item normandy' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Normandy`} title={_t('general_locations_normandie')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-normandy.jpg')} alt={`View of ${_t('general_locations_normandie')}`} title={_t('general_locations_normandie')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_normandie') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item lisbon' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Lisbon`} title={_t('general_locations_lisbon')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-lisbon.jpeg')} alt={`View of ${_t('general_locations_lisbon')}`} title={_t('general_locations_lisbon')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_lisbon') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item basque-country' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Basque`} title={_t('general_locations_basque')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-basque-country.jpeg')} alt={`View of ${_t('general_locations_basque')}`} title={_t('general_locations_basque')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_basque') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*      <div className="slide">*/}
          {/*        <a className='destination-item cape-town' href={`${HOST_URL}/${this.props.state.locale}/search/?q=Cape%20Town`} title={_t('general_locations_cape_town')}>*/}
          {/*          <img className='bg' src={require('../images/home-page/bg-cape-town.jpg')} alt={`View of ${_t('general_locations_cape_town')}`} title={_t('general_locations_cape_town')} />*/}
          {/*          <div className='destination-item-title' dangerouslySetInnerHTML={{ __html: _t('general_locations_cape_town') }}></div>*/}
          {/*        </a>*/}
          {/*      </div>*/}
          {/*    </Slider>*/}
          {/*  </div>*/}
          {/*</section>*/}


          {/*<section className='mail-section'>*/}
          {/*  <div className='container'>*/}
          {/*    <div className='row'>*/}
          {/*      <div className='col-md-12'>*/}
          {/*        <div className='mail-section-content'>*/}
          {/*          <h2 className='mail-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_email_get_discount') }}></h2>*/}
          {/*          <p className='mail-section-sub-title' dangerouslySetInnerHTML={{ __html: _t('homepage_email_get_code') }}></p>*/}
          {/*          <div className='mail-section-form'>*/}
          {/*            <div className='mail-section-form-title' dangerouslySetInnerHTML={{ __html: _t('homepage_email_to_which') }}></div>*/}
          {/*            <div className='mail-section-form-controls clearfix'>*/}
          {/*              <form action="https://handiscover.us11.list-manage.com/subscribe/post?u=9438a39ce9dfc3f6976805284&amp;id=8cd519dffe" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" noValidate>*/}
          {/*                <div className="hidden" aria-hidden="true">*/}
          {/*                  <input type="text" name="b_9438a39ce9dfc3f6976805284_8cd519dffe" tabIndex="-1" />*/}
          {/*                </div>*/}
          {/*                <input type="email" name="EMAIL" className='mail-section-form-input' id="mce-EMAIL" aria-label={_t('homepage_enter_email')} placeholder="Email" required />*/}
          {/*                <button className='mail-section-form-button' dangerouslySetInnerHTML={{ __html: _t('general_send') }}></button>*/}
          {/*              </form>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</section>*/}

          <section className="accessible-travel-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="accessible-travel-title"
                    dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_travel_guides') }}>
                  </div>
                  <div className="accessible-travel-text"
                    dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_travel_text') }}>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12 col-xs-12">
                  <a className="accessible-travel-item big croatia" href={'/en-gb/content/wheelchair-accessible-zadar'} title={_t('general_countries_croatia')}>
                    <img className='bg' src={require('../images/home-page/bg-croatia.jpg')} alt={`View of ${_t('general_countries_croatia')}`} title={_t('general_countries_croatia')} />
                    <div className="info-holder">
                      <div className="sub-title" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_favorite') }}></div>
                      <div className="title" dangerouslySetInnerHTML={{ __html: _t('general_countries_croatia') }}></div>
                      <div className="divider"></div>
                      <div className="text" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_favorite_text') }}>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-8 col-sm-12 col-xs-12">
                  <div className="row small-items">
                    <div className="col-md-6 col-sm-6 col-xs-12">
                      <a className="accessible-travel-item lisbon" href={'/en-gb/content/wheelchair-accessible-lisbon'} title={_t('general_locations_lisbon')}>
                        <img className='bg' src={require('../images/home-page/bg-lisbon.jpeg')} alt={`View of ${_t('general_locations_lisbon')}`} title={_t('general_locations_lisbon')} />
                        <div className="info-holder">
                          <div className="title" dangerouslySetInnerHTML={{ __html: _t('general_locations_lisbon') }}></div>
                          <div className="text" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_lisbon_text') }}>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12">
                      <a className="accessible-travel-item barcelona" href={'/en-gb/content/wheelchair-accessible-barcelona/'} title={_t('general_locations_barcelona')}>
                        <img className='bg' src={require('../images/home-page/barcelona.jpg')} alt={`View of ${_t('general_locations_barcelona')}`} title={_t('general_locations_barcelona')} />
                        <div className="info-holder">
                          <div className="title" dangerouslySetInnerHTML={{ __html: _t('general_locations_barcelona') }}></div>
                          <div className="text" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_barcelona_text') }}>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12">
                      <a className="accessible-travel-item london" href={'/en-gb/content/wheelchair-accessible-london'} title={_t('general_locations_london')}>
                        <img className='bg' src={require('../images/home-page/bg-london.jpg')} alt={`View of ${_t('general_locations_london')}`} title={_t('general_locations_london')} />
                        <div className="info-holder">
                          <div className="title" dangerouslySetInnerHTML={{ __html: _t('general_locations_london') }}></div>
                          <div className="text" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_london_text') }}>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12">
                      <a className="accessible-travel-item mallorca" href={'/en-gb/content/wheelchair-accessible-mallorca'} title={_t('general_locations_mallorca')}>
                        <img className='bg' src={require('../images/home-page/mallorca.jpg')} alt={`View of ${_t('general_locations_mallorca')}`} title={_t('general_locations_mallorca')} />
                        <div className="info-holder">
                          <div className="title" dangerouslySetInnerHTML={{ __html: _t('general_locations_mallorca') }}></div>
                          <div className="text" dangerouslySetInnerHTML={{ __html: _t('homepage_accessible_mallorca_text') }}>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 see-more-link-holder">
                  <a className="see-more-link" href={'/en-gb/content/results/destination'}
                    dangerouslySetInnerHTML={{ __html: _t('general_more') }}>
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/*<section className='ignite-section'>*/}
          {/*  <div className='container'>*/}
          {/*    <div className='row'>*/}
          {/*      <div className='col-md-12 ignite-section-content-wrapper'>*/}
          {/*        <div className='ignite-section-content-cell'>*/}
          {/*          <div className='ignite-section-content'>*/}
          {/*            <h2 className='ignite-section-title' dangerouslySetInnerHTML={{ __html: _t('homepage_ignite_section_title') }}></h2>*/}
          {/*            <div className='ignite-section-text' dangerouslySetInnerHTML={{ __html: _t('homepage_ignite_section_text') }}>*/}
          {/*            </div>*/}
          {/*            <button*/}
          {/*              className='ignite-section-button'*/}
          {/*              onClick={this.onClickListYourProperty.bind(this)}*/}
          {/*              dangerouslySetInnerHTML={{ __html: _t('homepage_ignite_section_button') }}>*/}
          {/*            </button>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</section>*/}

          <section className='mobility-section' id="how_mobile_are_you">
            <div className="container">
              <div className='mobility-section-title'>
                <h2 dangerouslySetInnerHTML={{ __html: _t('landing_page_mobility_header') }}></h2>
              </div>
              <div className='mobility-section-text'>
                <h3 dangerouslySetInnerHTML={{ __html: _t('landing_page_mobility_text') }}></h3>
              </div>
              <div className='info-cards row'>
                <div className='info-card-box col-md-4 col-sm-4 col-xs-12'>
                  <div className='info-card'>
                    <div className='image c1'></div>
                    <h3 dangerouslySetInnerHTML={{ __html: _t('landing_page_category_1_header') }}></h3>
                    <p dangerouslySetInnerHTML={{ __html: _t('landing_page_category_1_text') }}></p>
                  </div>
                </div>
                <div className='info-card-box col-md-4 col-sm-4 col-xs-12'>
                  <div className='info-card'>
                    <div className='image c2'></div>
                    <h3 dangerouslySetInnerHTML={{ __html: _t('landing_page_category_2_header') }}></h3>
                    <p dangerouslySetInnerHTML={{ __html: _t('landing_page_category_2_text') }}></p>
                  </div>
                </div>
                <div className='info-card-box col-md-4 col-sm-4 col-xs-12'>
                  <div className='info-card'>
                    <div className='image c3'></div>
                    <h3 dangerouslySetInnerHTML={{ __html: _t('landing_page_category_3_header') }}></h3>
                    <p dangerouslySetInnerHTML={{ __html: _t('landing_page_category_3_text') }}></p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="accessibility-banner-section">
            <div className="container">
              <h2 id="accessibility-banner-title" dangerouslySetInnerHTML={{ __html: _t('acc_banner_header') }}>
                {/* <b dangerouslySetInnerHTML={{ __html: _t('acc_banner_header') }} /> */}
                {/* <b dangerouslySetInnerHTML={{ __html: _t('acc_banner_header_bold') }} /> */}
              </h2>
              <div className="accessibility-banner-topics-wrapper">
                <div className="accessibility-banner-topics">
                  <a target="_blank" href={`https://www.haccess.io${haccessURLLang}`} >
                    <img className="topic-icon" src={require("../images/landing-page/accessibility-section/accessibility-b2b-round.png")} alt="Accessibility B2B icon" />
                  </a>
                  <h4 dangerouslySetInnerHTML={{ __html: _t('acc_banner_subheader1') }} />
                  <p dangerouslySetInnerHTML={{ __html: _t('acc_banner_subdescription1') }} />
                  <div className="learn-more-wrapper">
                    <a target="_blank" href={`https://www.haccess.io${haccessURLLang}`} >
                      <span dangerouslySetInnerHTML={{ __html: _t('acc_banner_learn_more') }} />
                      <img className="learn-more-arrow" src={require("../images/landing-page/accessibility-section/button-arrow.png")} alt="Button Arrow icon" /></a>
                  </div>
                </div>
                <div className="accessibility-banner-topics">
                  <a target="_blank" href={`https://accesscity.tech/`} >
                    <img className="topic-icon" src={require("../images/landing-page/accessibility-section/accessibility-b2g-round.png")} alt="Accessibility B2G icon" />
                  </a>
                  <h4 dangerouslySetInnerHTML={{ __html: _t('acc_banner_subheader2') }}></h4>
                  <p dangerouslySetInnerHTML={{ __html: _t('acc_banner_subdescription2') }}>
                  </p>
                  <div className="learn-more-wrapper">
                    <a target="_blank" href={`https://accesscity.tech/`} >
                      <span dangerouslySetInnerHTML={{ __html: _t('acc_banner_learn_more') }} />
                      <img className="learn-more-arrow" src={require("../images/landing-page/accessibility-section/button-arrow.png")} alt="Button Arrow icon" /></a>
                  </div>
                </div>
              </div>
              {/* <h3 id="accessibility-banner-footer-title" dangerouslySetInnerHTML={{ __html: _t('acc_banner_closing_description') }}></h3>
              <div id="accessibility-banner-button-container">
                <a target="_blank" href={`https://www.haccess.io${haccessURLLang}`} id="accessibility-banner-button" dangerouslySetInnerHTML={{ __html: _t('acc_banner_check_button') }}></a>
              </div> */}
            </div>
          </section>

          <section className="featured-section">
            <div className="container">
              <div className="featured-section-title" dangerouslySetInnerHTML={{ __html: _t('homepage_featured_section_title') }}>
              </div>
              <div className="featured-section-text" dangerouslySetInnerHTML={{ __html: _t('landing_page_featured_in_subheader') }}>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://www.theguardian.com/small-business-network/2017/may/05/disability-businesses-breaking-down-barriers?CMP=share_btn_tw" className="featured-item guardian" aria-label="featured partners the guardian"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="http://community.today.com/parentingteam/post/5-sizzling-summer-travel-tips" className="featured-item today" aria-label="featured partners today"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://issuu.com/thebeaconnewspapers/docs/bsbca92816.1_72_lr?utm_content=buffer4f0a0&utm_medium=social&utm_source=linkedin.com&utm_campaign=buffer" className="featured-item beacon" aria-label="featured partners the beacon"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://motherboard.vice.com/en_us/article/these-startups-hope-to-give-black-travelers-a-less-racist-alternative-to-airbnb" className="featured-item motherboard" aria-label="featured partners motherboard"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://www.huffingtonpost.com/entry/entrepreneurial-hack-how-travel-can-keep-your-productivity_us_5955302de4b0326c0a8d0e8a" className="featured-item huffington " aria-label="featured partners, huffington"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://www.nytimes.com/2017/09/25/travel/wheelchair-racer-aron-anderson-travel.html" className="featured-item nytimes" aria-label="featured partners new york times"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://yoocanfind.com/ServiceProvider/67/handiscover" className="featured-item yoocan" aria-label="featured partners yoocan"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="http://www.musculardystrophyuk.org/get-involved/friends-of-mduk/" className="featured-item mduk" aria-label="featured partners muscular dystrophy uk"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://pantou.org/" className="featured-item pantou" aria-label="featured partners pantou"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="http://www.accessibletourism.org/?i=enat.en" className="featured-item enat" aria-label="featured partners ENAT"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://aws.amazon.com/solutions/case-studies/handiscover/" className="featured-item aws" aria-label="featured partners amazon web services"></a>
                </div>
                <div className="col-md-2 col-sm-4 col-xs-6">
                  <a target="_blank" href="https://amadeus.com/en/insights/blog/handiscover-accessible-accommodation" className="featured-item amadeus" aria-label="featured partners amadeus"></a>
                </div>
                <div className="col-12">
                  <a target="_blank" href="https://ec.europa.eu/programmes/horizon2020/h2020-sections" className="featured-item-eic">
                    <img src={require('../images/home-page/eic-image.svg')} alt="eic logo" />
                  </a>
                </div>
              </div>
            </div>
          </section>

        </div>

        {
          this.renderLoginModal()
        }
        {/*<SubFooter*/}
        {/*  locale={this.props.state && this.props.state.locale ? this.props.state.locale : null}*/}
        {/*  deviceSize={this.props.state.noStore.deviceSize}*/}
        {/*/>*/}

      </div>
    )
  }
}

export default translate()(HomePage)
